
import React from 'react';

interface BikeBasicInfoProps {
  model?: string;
  serialNumber?: string;
}

export const BikeBasicInfo: React.FC<BikeBasicInfoProps> = ({ model, serialNumber }) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <div>
        <p className="text-sm text-muted-foreground">Модель</p>
        <p className="font-medium">{model || 'Не указана'}</p>
      </div>
      <div>
        <p className="text-sm text-muted-foreground">Серийный номер</p>
        <p className="font-medium">{serialNumber || 'Не указан'}</p>
      </div>
    </div>
  );
};
